"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var ComponentTargetID = function ComponentTargetID(_ref) {
  var sliceData = _ref.sliceData;

  if (sliceData[0].element_id.length === 0) {
    return null;
  }

  return sliceData.map(function (_ref2) {
    var element_id = _ref2.element_id;
    return element_id.map(function (_ref3) {
      var text = _ref3.text;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: text,
        className: "info-list__component-target",
        id: text
      });
    });
  });
};

ComponentTargetID.prototype = {
  element_id: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    text: _propTypes["default"].string
  }))
};
var _default = ComponentTargetID;
exports["default"] = _default;